import { format } from 'date-fns';
import { formatInTimeZone, toZonedTime } from 'date-fns-tz';

const IST_TIMEZONE = 'Asia/Kolkata';

/**
 * Get current date and time in IST
 * @returns {Date} Current date in IST
 */
export const getCurrentISTTime = () => {
  return toZonedTime(new Date(), IST_TIMEZONE);
};

/**
 * Format date to IST string
 * @param {Date} date - Date to format
 * @param {string} formatString - Format string (default: 'yyyy-MM-dd HH:mm:ss')
 * @returns {string} Formatted date string in IST
 */
export const formatToIST = (date, formatString = 'yyyy-MM-dd HH:mm:ss') => {
  if (!date) return '';
  return formatInTimeZone(date, IST_TIMEZONE, formatString);
};

/**
 * Convert any date to IST timezone
 * @param {Date} date - Date to convert
 * @returns {Date} Date in IST
 */
export const convertToIST = (date) => {
  return toZonedTime(date, IST_TIMEZONE);
};

/**
 * Get IST date string (YYYY-MM-DD)
 * @param {Date} date - Date object
 * @returns {string} Date string in IST
 */
export const getISTDateString = (date = new Date()) => {
  return formatInTimeZone(date, IST_TIMEZONE, 'yyyy-MM-dd');
};

/**
 * Get IST time string (HH:mm:ss)
 * @param {Date} date - Date object
 * @returns {string} Time string in IST
 */
export const getISTTimeString = (date = new Date()) => {
  return formatInTimeZone(date, IST_TIMEZONE, 'HH:mm:ss');
};

/**
 * Format date for display (15 Nov 2025, 14:30)
 * @param {Date} date - Date to format
 * @returns {string} Formatted date string
 */
export const formatDisplayDateTime = (date) => {
  if (!date) return '';
  return formatInTimeZone(date, IST_TIMEZONE, 'dd MMM yyyy, HH:mm');
};

/**
 * Format date range for display
 * @param {Date} startDate - Start date
 * @param {Date} endDate - End date
 * @returns {string} Formatted date range
 */
export const formatDateRange = (startDate, endDate) => {
  if (!startDate || !endDate) return '';
  const start = formatInTimeZone(startDate, IST_TIMEZONE, 'dd MMM yyyy, HH:mm');
  const end = formatInTimeZone(endDate, IST_TIMEZONE, 'HH:mm');
  return `${start} - ${end}`;
};

/**
 * Parse date string to Date object
 * @param {string} dateString - Date string (YYYY-MM-DD)
 * @param {string} timeString - Time string (HH:mm:ss)
 * @returns {Date} Date object
 */
export const parseDateTime = (dateString, timeString) => {
  const dateTimeString = `${dateString}T${timeString}`;
  return new Date(dateTimeString);
};
